export const USERPERMISSIONS_SET_USERPERMISSIONS = "user/get-user-permissions";
